import { styled } from '@mui/material'
import { MapContainer } from 'react-leaflet'

export const MapWrapper = styled(MapContainer, {
  shouldForwardProp: (props) => props !== 'width' && props !== 'height',
})<{ width: string; height: string }>(({ width, height }) => ({
  height,
  width,
  transition: 'height 2s',
}))
